import Cookies from 'js-cookie';
import ConfigJSON from '../../../config.json';

export default function () {
    console.log('myAcc from router');

    jQuery(document).ready(function ($) {
        $('.myusa-login-form').on('submit', function (e) {
            e.preventDefault();
            console.log('Try login');

            let email = $(this).find('input[name="email"]');
            let pass = $(this).find('input[name="pass"]')

            $.ajax({
                url: LK.api_domain + '/auth',
                method: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                data: JSON.stringify({
                    email: email.val().trim(),
                    password: pass.val().trim(),
                }),
                complete: function (jqXHR, status) {
                    if (jqXHR.status == 200) { // if we login success and have tokin
                        let token = jqXHR.getResponseHeader('Authorization');
                        Cookies.set('lk-bearer', token, { expires: 2 });
                        window.location = '/lk/orders';
                    } else { // if somthing wrong
                        $(pass).next('.input_error').text('Your username or password is wrong, please try again').show();
                    }
                }
            });
        });
    });
};